import Box from "./Box";
import React from "react";

export default function Stack({ children, itemBoxProps, divider }) {
  return children.map((child, index) => {
    const isFirstItem = index === 0;
    const isLastItem = index === children.length - 1;
    let { pt, pb } = itemBoxProps;
    if (pt === undefined) pt = 20;
    if (pb === undefined) pb = 20;
    if (child.length === 0) return undefined;
    return (
      <React.Fragment key={index}>
        {!isFirstItem && divider}
        <Box
          {...itemBoxProps}
          pt={isFirstItem ? undefined : pt}
          pb={isLastItem ? undefined : pb}
        >
          {child}
        </Box>
      </React.Fragment>
    );
  });
}
Stack.defaultProps = {
  itemBoxProps: {},
};
